<template>
    <van-row class="safe">
        <van-col span="24">
            <van-row class="safe_title">
                <van-col span="24">{{ $t('index.sstitle') }}</van-col>
            </van-row>
            <van-row class="safe_num">
                <van-col span="8" class="safe_gz">{{operation.safeday}}{{ $t('index.day') }}</van-col>
                <van-col span="8" class="safe_gz">{{operation.amount}}{{ $t('index.yy') }}</van-col>
                <van-col span="8" class="safe_gz">{{operation.people}}{{ $t('index.wp') }}</van-col>
            </van-row>
            <van-row class="safe_desc">
                <van-col span="8">{{ $t('index.safe_desc1') }}</van-col>
                <van-col span="8">{{ $t('index.safe_desc2') }}</van-col>
                <van-col span="8">{{ $t('index.safe_desc3') }}</van-col>
            </van-row>
        </van-col>
    </van-row>
</template>

<script>
    export default {
        name: "Safe",
        data(){
          return{

          }
    },
        props:{
            operation:{
                type:Object,
                required:true
            }
        }
    }
</script>

<style scoped lang="scss">
    .safe{
        width: 92%;
        height: 100px;
        margin: 0 auto 10px auto;
        background: white;
        border-radius: 10px;
        .safe_title{
            width: 100%;
            height: 35px;
            line-height: 35px;
            color: #666;
            font-size: 16px;
            font-weight: bold;
            text-align: left;
            text-indent: 10px;
            background: url("~@/assets/images/bg_group_suggest.png") no-repeat;
            background-size: 100% 100%;
        }
        .safe_num{
            margin: 10px;
            font-size: 12px;
            font-weight: bold;
            .safe_gz{
                border-left: 2px solid red;
            }

        }
        .safe_desc{
            font-size: 10px;
        }
    }
</style>
